import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  ClusterStoreActions,
  ClusterStoreSelectors,
  ClusterStoreReducer,
} from './index';
import { ClusterDto } from '@cradua/data';

@Injectable()
export class ClusterFacade {
  constructor(private store: Store<ClusterStoreReducer.ClusterPartialState>) {}

  clusterRecord$ = this.store.select(ClusterStoreSelectors.getSelected);
  clusterRecordError$ = this.store.select(
    ClusterStoreSelectors.getClusterError
  );

  getselected() {
    return this.store.select(ClusterStoreSelectors.getSelected);
  }

  get isLoadingCluster() {
    this.store.dispatch(ClusterStoreActions.loadCluster());
    return this.store.select(ClusterStoreSelectors.loadingCluster);
  }

  get loadCluster() {
    this.store.dispatch(ClusterStoreActions.loadCluster());
    return this.store.select(ClusterStoreSelectors.getAllCluster);
  }

  addCluster(newCluster: ClusterDto[]) {
    this.store.dispatch(ClusterStoreActions.addCluster({ newCluster }));
  }

  updateCluster(updateCluster: ClusterDto[]) {
    this.store.dispatch(ClusterStoreActions.updateCluster({ updateCluster }));
  }

  removeCluster(ids: string[]) {
    this.store.dispatch(ClusterStoreActions.removeCluster({ ids }));
  }
}
